import { Component, OnInit, Input } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS, COLORS } from '../../../analytics/constants/analytics.constants';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { TooltipDirective } from 'ng2-tooltip-directive';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';

@Component({
	selector: 'app-r6-daypart',
	templateUrl: './r6-daypart.component.html',
	styleUrls: ['./r6-daypart.component.css']
})
export class R6DaypartComponent implements OnInit {
	@Input() colorsconfig: any;
	@Input() downloadconfig: any;
	@Input() sectiontitle: any;
	public reloadSubscription;
	public hasData = true;
	public showLoad = true;
	public widgetDataSubscription;
	public key: string;
	public dayPartData: any;
	public colorPalette: ColorPalette;
	public downloadConfiguration: DownloadConfig;
	public tooltipOptions = {
		placement: 'top',
		theme: 'light',
		'hide-delay': 100
	};
	public timezone: string = '';

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit() {
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.requestData();
	}

	requestData() {
		this.hasData = false;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processCustomServiceRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			this.timezone = res && res.timezone ? '(' + res.timezone + ')' : '';
			if (res.success && res.data.length > 0) {
				let res_data = res.success ? res.data : [];
				this.hasData = res.success;
				this.processResponseData(res_data);
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(response) {
		if (response) {
			const totalImpressions = response.reduce((initialVal, obj) => initialVal + parseInt(obj.impressions), 0);
			this.dayPartData = response.map((item, i) => {
				item.percentage = (item.impressions / totalImpressions) * 100;
				if (item.percentage < 4 && (i === 0 || i === response.length - 1)) item.percentage = 4;
				if (this.colorsconfig[i].isHex) {
					item.color = this.colorsconfig[i].color;
				} else {
					item.color = this.colorPalette[this.colorsconfig[i].color + 'Color'];
				}
				return item;
			});
		}
	}

	downloadCSV() {
		this.analyticsService.downloadCSV(this.downloadConfiguration.csvQueryKey, this.downloadConfiguration.fileName);
	}
}
